var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-container',[_c('MainNew'),_c('applicationCenter'),_c('Hotspot'),_c('IndustryChoice'),_c('el-footer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }